var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useNavigate } from '@thd-olt-component-react/router';
import React, { useEffect, useState } from 'react';
import { ConnectBuildertrendAccount } from '../../../hooks/purchase-history-hooks';
import { getBTLinkParams } from '../../../utils/buildertrend-utils';
import { getWindow } from '../../../utils/general';
import { BuildertrendModal } from './buildertrend-modal/BuildertrendModal';
var generateButtonText = function (userIsLinked) {
    if (userIsLinked) {
        return 'Disconnect Buildertrend';
    }
    return 'Connect Buildertrend';
};
export var BuildertrendButton = function () {
    var _a, _b, _c, _d;
    // Admin unlink radio buttons state
    var _e = useState('user'), adminUnlinkRadio = _e[0], setAdminUnlinkRadio = _e[1];
    var _f = useState(false), open = _f[0], setOpen = _f[1];
    var _g = useState({
        isLoading: false,
        btResponse: undefined,
    }), btApiState = _g[0], setBtApiState = _g[1];
    var navigate = useNavigate();
    var handleClose = function () {
        var _a;
        setOpen(false);
        if (btApiState.btResponse !== undefined) {
            navigate();
            (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location.reload();
        }
    };
    var handleOpen = function () { return setOpen(true); };
    var btLinkStatusCheck = ((_c = (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.THD_CUST_ACCOUNT_OM) === null || _b === void 0 ? void 0 : _b.userState) === null || _c === void 0 ? void 0 : _c.btLinkStatus) || '';
    var paramsInfo = ((_d = getWindow()) === null || _d === void 0 ? void 0 : _d.location.search) || '';
    var _h = getBTLinkParams(paramsInfo), code = _h.code, state = _h.state;
    var userIsLinked = btLinkStatusCheck === 'ACTIVE';
    useEffect(function () {
        if (code && state === 'STATE') {
            // Checkes if redirected from buildertrend to continue connection process
            handleOpen();
            ConnectBuildertrendAccount(code, btApiState, setBtApiState);
        }
    }, []);
    var BuildertrendModalProps = {
        open: open,
        handleOpen: handleOpen,
        handleClose: handleClose,
        userIsLinked: userIsLinked,
        adminUnlinkRadio: adminUnlinkRadio,
        setAdminUnlinkRadio: setAdminUnlinkRadio,
        btApiState: btApiState,
        setBtApiState: setBtApiState,
    };
    return (React.createElement("div", { className: "sui-flex sui-items-center" },
        React.createElement("img", { src: "https://assets.thdstatic.com/images/v1/BuildertrendIcon.svg", alt: "Buildertrend Icon", width: "20px", height: "25px" }),
        React.createElement("button", { "data-testid": "buildertrend-button", type: "button", className: "sui-underline", onClick: function () {
                handleOpen();
            } },
            React.createElement("div", { style: { display: 'flex' } },
                React.createElement("p", { style: { paddingTop: 3, paddingLeft: 5 } }, generateButtonText(userIsLinked)))),
        React.createElement(BuildertrendModal, __assign({}, BuildertrendModalProps))));
};
